import styled from 'styled-components';
import { Col } from 'antd';

export const Container = styled(Col)`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 80%;
`;
